import { css } from 'styled-system/css';

export const productStyle = {
	product: css({
		display: 'flex',
		flexDir: 'column',
		justifyContent: 'center',
		gap: '12px',
		w: '100%',
		p: '12px',
		bgColor: 'jupiter.site.productBg',
		lg: {
			mt: '24px',
			borderRadius: '12px',
		},
	}),
	optionsSwiper: css({
		pt: '6px',
		maxW: '100%',
		minH: '112px',
		'& .swiper-button-prev, .swiper-button-next': {
			'&::before': {
				bgImage: 'none',
				bgColor: 'jupiter.site.productBg',
			},
			'&::after': {
				bgColor: 'jupiter.grey.60',
			},
		},
		'& .swiper-button-prev': {
			'&::before': {
				maskImage: 'linear-gradient(to left, #0000, #000)',
			},
		},
		'& .swiper-button-next': {
			'&:before': {
				maskImage: 'linear-gradient(to right, #0000, #000)',
			},
		},
	}),
	optionItem: css({
		width: '100px',
		textAlign: 'center',
		cursor: 'pointer',
		color: 'jupiter.grey.60',
		_supportHover: {
			transition: 'transform 200ms ease-in',
			_hover: {
				transform: 'scale(1.1)',
			},
		},
		'&[data-selected="true"]': {
			color: 'jupiter.main.highlight',
			'& .jupiter-home__option-bg': {
				bgColor: 'jupiter.main.highlight',
			},
		},
	}),
	optionBg: css({
		pos: 'absolute',
		w: '100%',
		h: '100%',
		zIndex: 1,
		maskImage: 'url(/images/home/nav/icon-bg.png)',
		maskRepeat: 'no-repeat',
		maskPosition: 'center top',
		maskSize: '72px',
		bgColor: '#BCBCBC', // 不配亮暗版
	}),
	optionIcon: css({
		pos: 'relative',
		zIndex: 2,
	}),
	optionText: css({
		fontSize: '14px',
	}),
	newWindow: css({
		pos: 'absolute',
		bottom: 0,
		right: '10px',
		ml: '8px',
		bgColor: 'jupiter.common.white',
		borderRadius: '6px',
		color: 'jupiter.site.primaryFixed',
		'& .icon': {
			display: 'block',
			w: '24px',
			h: '24px',
		}
	}),
	market: css({
		display: 'flex',
		justifyContent: 'center',
		p: '6px',
	}),
	marketGroup: css({
		display: 'flex',
		bgColor: 'jupiter.grey.20',
		p: '3px',
		borderRadius: '24px',
		gap: '6px',
	}),
	marketItem: css({
		position: 'relative',
		display: 'flex',
		alignItems: 'center',
		py: '6px',
		px: '12px',
		gap: '6px',
		borderRadius: '24px',
		color: 'jupiter.grey.70',
		cursor: 'pointer',
		_active: {
			bgColor: 'jupiter.main.primary',
			color: 'jupiter.grey.10',
		},
		'& .icon--filter-live': {
			color: 'var(--special-09)',
			_site42021: {
				color: 'jupiter.common.white',
			}
		},
		_supportHover: {
			transition: 'background-color 200ms ease-in',
			'&:not([data-active="true"])': {
				_hover: {
					bgColor: '#CCC3'
				},
			}
		},
		'& .symbol--bet-builder-plus': {
			transform: 'translateX(2px)',
		},
		'& .new-tag': {
			position: 'absolute',
			top: '-3px',
			left: 0,
		},
	}),
	marketLabel: css({
		fontSize: '14px',
	}),
	marketCount: css({
		bgColor: 'jupiter.grey.10',
		color: 'jupiter.grey.70',
		px: '3px',
		borderRadius: '6px',
		_groupActive: {
			color: 'jupiter.main.primary',
		},
	}),
	liveIcon: css({
		pos: 'absolute',
		left: '3px',
		top: '3px',
		color: 'var(--special-09)',
	}),
	activityBanner: css({
		margin: '0 auto',
		width: '280px',
	}),
	productList: css({
		display: 'flex',
		flexWrap: 'wrap',
		gap: '12px',
		justifyContent: 'center',
	}),
	productItem: css({
		position: 'relative',
		w: {
			base: 'calc((100% - 12px)/2)',
			md: 'calc((100% - 24px)/3)',
			lg: 'calc((100% - 36px)/4)',
			lgx: 'calc((100% - 48px)/5)',
		},
		borderRadius: '6px',
		borderWidth: '1px',
		borderColor: 'jupiter.main.primary',
		bgImage: 'linear-gradient(to right, #CBCBCB00, #CBCBCB33)', // 亮暗版同色
		cursor: 'pointer',
		transition: 'all 200ms ease-in',
		_supportHover: {
			_hover: {
				boxShadow: '0 3px 9px rgba(0, 0, 0, .38)',
				transform: 'translateY(-3px)',
			},
		},
		_disabled: {
			cursor: 'default',
			borderColor: 'jupiter.grey.60',
		},
		'& .new-tag': {
			position: 'absolute',
			top: '-6px',
			left: '-6px',
			zIndex: 3,
		},
	}),
	productItemTag: css({
		position: 'absolute',
		left: '9px',
		bottom: '12px',
		zIndex: 2,
		fontSize: '16px',
		fontWeight: '700',
	}),
	productBg: css({
		pos: 'relative',
		display: 'flex',
		justifyContent: 'flex-end',
		bgImage: 'url("/images/jupiter/global/product-list-bg.png")',
		bgRepeat: 'no-repeat',
		bgSize: 'contain',
		bgPosition: 'left top',
		overflow: 'hidden',
		'& img': {
			transition: 'transform 200ms ease-in',
			transform: 'scale(1)',
			transformOrigin: '100% 100%',
			_groupHover: {
				transform: 'scale(1.1)',
			},
			_groupDisabled: {
				filter: 'grayscale(100%)',
				opacity: 0.8,
			},
		},
	}),
	productCount: css({
		pos: 'absolute',
		left: '12px',
		bottom: '6px',
		color: 'jupiter.main.primary',
		fontSize: '40px',
		lineHeight: 1,
		fontWeight: '700',
	}),
	productName: css({
		bgColor: 'jupiter.main.primary',
		color: 'jupiter.grey.10',
		fontSize: '14px',
		py: '3px',
		px: '12px',
		borderRadius: '0 0 4px 4px',
		_groupDisabled: {
			bgColor: 'jupiter.grey.60',
		},
	}),
}